@if (hasEntitlement) {
  <div>
    <div>
      <h2>Upload Tracking Number - {{fileId}}</h2>
    </div>
    <div>
      <div class="filters-container">
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input [formControl]="subscriberNameFilter" matInput placeholder="Search" #input />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Date of Birth</mat-label>
          <input [formControl]="dobFilter" matInput placeholder="Search" #input />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Relationship to Subscriber</mat-label>
          <input [formControl]="relationshipFilter" matInput placeholder="Search" #input />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Application Number</mat-label>
          <input [formControl]="appNumberFilter" matInput placeholder="Search" #input />
        </mat-form-field>
      </div>
      <mat-table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="arrow">
          <mat-header-cell *matHeaderCellDef>
          </mat-header-cell>
          <mat-cell class="no-children" *matCellDef="let app">
            @if (app.subscriber.spouse || app.subscriber.dependents?.length > 0) {
              <span class="material-symbols-outlined" (click)="expand(app)">{{accordianArrowIcon}}
              </span>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="fullName">
          <mat-header-cell *matHeaderCellDef>Name
          </mat-header-cell>
          <mat-cell *matCellDef="let app" [ngClass]="{'underline-row': true}">
            @if (app.subscriber.spouse || app.subscriber.dependents?.length > 0) {
              <mat-expansion-panel hideToggle
                [expanded]="expandedRows[app.subscriber.appTrackingId]" (click)="expand(app)">
                <mat-expansion-panel-header>{{app.subscriber.fullName}}</mat-expansion-panel-header>
                <div class="nested-table-content dependent-name-container">
                  @if (app.subscriber.spouse?.fullName) {
                    <div class="nested-entry">{{app.subscriber.spouse.fullName}}</div>
                  }
                  @for (dep of app.subscriber.dependents; track dep) {
                    <div class="nested-entry">{{dep.fullName}} </div>
                  }
                </div>
              </mat-expansion-panel>
            }
            @if (!app.subscriber.spouse && 1 > app.subscriber.dependents?.length) {
              <div class="subscriber-no-dependents-container">
              {{app.subscriber.fullName}}</div>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="dob">
          <mat-header-cell *matHeaderCellDef>Date of Birth
          </mat-header-cell>
          <mat-cell *matCellDef="let app">
            @if (app.subscriber.spouse || app.subscriber.dependents?.length > 0) {
              <mat-expansion-panel hideToggle
                [expanded]="expandedRows[app.subscriber.appTrackingId]" (click)="expand(app)">
                <mat-expansion-panel-header>{{app.subscriber.dob}}</mat-expansion-panel-header>
                <div class="nested-table-content">
                  @if (app.subscriber.spouse?.dob) {
                    <div class="nested-entry">{{app.subscriber.spouse.dob}}</div>
                  }
                  @for (dep of app.subscriber.dependents; track dep) {
                    <div class="nested-entry">{{dep.dob}}</div>
                  }
                </div>
              </mat-expansion-panel>
            }
            @if (!app.subscriber.spouse && 1 > app.subscriber.dependents?.length) {
              <div>{{app.subscriber.dob}}</div>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="relationship">
          <mat-header-cell *matHeaderCellDef>Relationship to Subscriber
          </mat-header-cell>
          <mat-cell *matCellDef="let app">
            @if (app.subscriber.spouse || app.subscriber.dependents?.length > 0) {
              <mat-expansion-panel hideToggle
                [expanded]="expandedRows[app.subscriber.appTrackingId]" (click)="expand(app)">
                <mat-expansion-panel-header>Subscriber</mat-expansion-panel-header>
                <div class="nested-table-content">
                  @if (app.subscriber.spouse) {
                    <div class="nested-entry">Spouse</div>
                  }
                  @for (dep of app.subscriber.dependents; track dep) {
                    <div class="nested-entry">Dependent</div>
                  }
                </div>
              </mat-expansion-panel>
            }
            @if (!app.subscriber.spouse && 1 > app.subscriber.dependents?.length) {
              <div>Subscriber</div>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="appTrackingId">
          <mat-header-cell *matHeaderCellDef>Application Number
          </mat-header-cell>
          <mat-cell *matCellDef="let app">
            @if (app.subscriber.spouse || app.subscriber.dependents?.length > 0) {
              <mat-expansion-panel hideToggle
                [expanded]="expandedRows[app.subscriber.appTrackingId]" (click)="expand(app)">
                <mat-expansion-panel-header>{{app.subscriber.appTrackingId}}</mat-expansion-panel-header>
                <div class="nested-table-content">
                  @if (app.subscriber.spouse) {
                    <div class="nested-entry">-</div>
                  }
                  @for (dep of app.subscriber.dependents; track dep; let last = $last) {
                    <div class="nested-entry">
                      <span [class.last-element]="last">-</span>
                    </div>
                  }
                </div>
              </mat-expansion-panel>
            }
            @if (!app.subscriber.spouse && 1 > app.subscriber.dependents?.length) {
              <div>{{app.subscriber.appTrackingId}}</div>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="downloadApp">
          <mat-header-cell *matHeaderCellDef>Download Application
          </mat-header-cell>
          <mat-cell class="no-children" *matCellDef="let app">
            @if (app.subscriber.spouse || app.subscriber.dependents?.length > 0) {
              <mat-expansion-panel hideToggle
                [expanded]="expandedRows[app.subscriber.appTrackingId]" (click)="expand(app)">
                <mat-expansion-panel-header>
                  <span class="material-symbols-outlined" (click)="getLogByFileId(app.subscriber.appTrackingId)">download</span>
                </mat-expansion-panel-header>
                <div class="nested-table-content">
                  @if (app.subscriber.spouse) {
                    <div class="nested-entry hidden">-</div>
                  }
                  @for (dep of app.subscriber.dependents; track dep) {
                    <div class="nested-entry hidden">-</div>
                  }
                </div>
              </mat-expansion-panel>
            }
            @if (!app.subscriber.spouse && 1 > app.subscriber.dependents?.length) {
              <span class="material-symbols-outlined" (click)="getLogByFileId(app.subscriber.appTrackingId)">download</span>
            }
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" (click)="expand(app)"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>
  </div>
}

@if (!hasEntitlement) {
  <div>
    {{ noEntitlementsMessage || 'Your currently selected agency does not have access to view Submission Log. Try a
    different agency if available.'}}
  </div>
}

